import { useState } from "react";
import { FiGithub, FiLinkedin, FiMail, FiPhone, FiMessageCircle } from "react-icons/fi";
import { profile } from "../../data/portfolio";
import styles from "./Contact.module.css";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [status, setStatus] = useState("idle");
  const [errorDetail, setErrorDetail] = useState("");

  const onChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    setErrorDetail("");

    try {
      const response = await fetch(`https://formsubmit.co/ajax/${profile.email}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          _replyto: form.email,
          _subject: form.subject?.trim() || `Portfolio message from ${form.name}`,
          message: form.message,
        }),
      });

      const data = await response.json().catch(() => ({}));
      const failed = !response.ok || data.success === false || data.success === "false";

      if (failed) {
        const msg = data.message || "Unable to send right now";
        if (/activat/i.test(msg)) {
          setStatus("activate");
          setErrorDetail(msg);
          return;
        }
        throw new Error(msg);
      }

      setStatus("sent");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      setStatus("error");
      setErrorDetail(err.message || "Something went wrong");
    }
  };

  return (
    <section id="contact" className={`section ${styles.contact}`}>
      <div className="sectionHeader">
        <p className="sectionEyebrow">Contact</p>
        <h2 className="sectionTitle">Let’s build something strong</h2>
        <p className="sectionLead">
          Open to full-time software roles. Reach out for product work, interviews, or collaboration.
        </p>
      </div>

      <div className={styles.grid}>
        <div className={styles.info}>
          <a href={`mailto:${profile.email}`} className={styles.infoItem}>
            <FiMail />
            <div>
              <span>Email</span>
              <strong>{profile.email}</strong>
            </div>
          </a>
          <a href={`tel:${profile.phoneRaw}`} className={styles.infoItem}>
            <FiPhone />
            <div>
              <span>Phone</span>
              <strong>{profile.phone}</strong>
            </div>
          </a>
          <div className={styles.socials}>
            <a href={profile.links.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <FiLinkedin />
            </a>
            <a href={profile.links.github} target="_blank" rel="noreferrer" aria-label="GitHub">
              <FiGithub />
            </a>
            <a href={profile.links.whatsapp} target="_blank" rel="noreferrer" aria-label="WhatsApp">
              <FiMessageCircle />
            </a>
          </div>
        </div>

        <form className={styles.form} onSubmit={onSubmit}>
          <label>
            Name
            <input name="name" value={form.name} onChange={onChange} required placeholder="Your name" />
          </label>
          <label>
            Email
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={onChange}
              required
              placeholder="you@company.com"
            />
          </label>
          <label>
            Subject
            <input name="subject" value={form.subject} onChange={onChange} placeholder="Opportunity / hello" />
          </label>
          <label>
            Message
            <textarea
              name="message"
              value={form.message}
              onChange={onChange}
              required
              rows={5}
              placeholder="Tell me about the role or project"
            />
          </label>
          <button type="submit" disabled={status === "sending"}>
            {status === "sending" ? "Sending…" : "Send message"}
          </button>
          {status === "sent" && (
            <p className={styles.note}>Message sent — I’ll get back soon.</p>
          )}
          {status === "activate" && (
            <p className={styles.note}>
              Almost there — check <strong>{profile.email}</strong> and click the FormSubmit
              activation link once. After that, messages will arrive normally.
            </p>
          )}
          {status === "error" && (
            <p className={styles.error}>
              {errorDetail || "Something went wrong."}{" "}
              <a href={`mailto:${profile.email}`}>Email me directly</a>.
            </p>
          )}
        </form>
      </div>
    </section>
  );
}
